module.exports = __webpack_public_path__ + "static/media/personal.d33f7e4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/categories/personal.svg
// module id = 2167
// module chunks = 0